module.exports = __webpack_public_path__ + "img/contact.9601e1a1.svg";